var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38313 9.7832L4.31624 11.3623L6.05538 13.913L7.56262 16L9.18581 13.913L11.2728 10.8986L12.1588 9.28764C12.4179 8.8165 12.6374 8.32464 12.815 7.81712L13.0852 7.04521C13.2669 6.52604 13.3597 5.97993 13.3597 5.42988C13.3597 4.60594 13.1515 3.79536 12.7544 3.07342L12.7066 2.98637C12.2978 2.24313 11.7159 1.60941 11.0101 1.13889L10.8644 1.04174C10.5192 0.811634 10.1511 0.617992 9.76592 0.463928L9.55196 0.378342C8.92712 0.128408 8.26034 0 7.58737 0C6.88234 0 6.18441 0.140941 5.53462 0.414536L5.42555 0.460457C4.69438 0.76832 4.03706 1.2282 3.49723 1.80956C3.04209 2.2997 2.67856 2.86749 2.42389 3.48598L2.37409 3.6069C2.12541 4.21086 1.99829 4.85794 2.00002 5.51109C2.00136 6.01768 2.0802 6.5211 2.2338 7.00385L2.46681 7.73616C2.69421 8.45083 3.00159 9.13753 3.38313 9.7832ZM7.56262 8.34782C9.09941 8.34782 10.3452 7.10201 10.3452 5.56522C10.3452 4.02842 9.09941 2.78261 7.56262 2.78261C6.02582 2.78261 4.78001 4.02842 4.78001 5.56522C4.78001 7.10201 6.02582 8.34782 7.56262 8.34782Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationblue);
export default __webpack_public_path__ + "static/media/Locationblue.57c3dc5f708768cc6d26848a8c743462.svg";
export { ForwardRef as ReactComponent };